import { render } from "./AccesView.vue?vue&type=template&id=8a666d72"
import script from "./AccesView.vue?vue&type=script&lang=js"
export * from "./AccesView.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__